import { pinia } from '/stores'
import { createApp } from 'vue'
import { Config as JsFromRoutesConfig } from '@js-from-routes/client'
import { useCommonStore } from '/stores/common_store'
import { useNotificationsStore } from '/stores/notifications_store'

// fetch doesn't send X-Requested-With by default, so Rails request.xhr? returns false
// on JsFromRoutes calls. Re-add it so Rails-side xhr checks keep working.
const jsFromRoutesDefaultHeaders = JsFromRoutesConfig.headers
JsFromRoutesConfig.headers = (info) => ({
  ...jsFromRoutesDefaultHeaders(info),
  'X-Requested-With': 'XMLHttpRequest',
})

export function setup() {
  fetch('/app_config.json', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(response => response.json())
    .then(appConfig => initStores(appConfig))

  document.addEventListener('contextmenu', event => event.preventDefault())
  document.addEventListener('turbo:load', () => I18n.locale = document.documentElement.lang)
  document.addEventListener('turbo:visit', () => document.documentElement.classList.remove('scroll-lock'))
}

function initStores(appConfig) {
  const app = createApp({})
  app.use(pinia)

  const common = useCommonStore()
  common.currentUser = appConfig.config.current_user
  common.device = appConfig.config.device

  const notifications = useNotificationsStore()
  notifications.pmessages = appConfig.stats.new_pmessages_count
  notifications.kisses = appConfig.stats.new_kisses_count
  notifications.formViews = appConfig.stats.new_form_views_count
  notifications.matches = appConfig.stats.new_matches_count
  notifications.testimonials = appConfig.stats.new_testimonials_count
  notifications.socialNotifications = appConfig.stats.new_social_notifications_count
  notifications.events = appConfig.stats.events_count
}
